var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElTooltip',{attrs:{"content":_vm.$t('EDIT'),"placement":"top"}},[_c('ElButton',{staticClass:"table-cell-edit__button",attrs:{"plain":"","size":"mini","icon":"el-icon-edit"},on:{"click":_vm.openEditModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }